import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"
import Unit from "@fae/source/models/Unit.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"

import emberUnitJobs from "@fae/source/data/games/ember/unitJobs.jsx"
import * as PlotFlourishes from "@fae/source/data/plot/flourishes.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

// duped from data/skills.js
function canTarget({performerKey, stage, position}) {
    const performer = stage.units[performerKey]
    const target = Stage.findUnitByPosition(stage, position)
    if(target == undefined) return false
    if(target.key == performer.key) return false
    if(target.affiliation == undefined) return false
    if(target.affiliation == "none") return false
    if(target.affiliation == "nothing") return false // TODO: should this be a check for type == "thing"??
    return true
}

// duped from data/skills.js
function getSupportPriority({performerKey, stage, position}) {
    const performer = stage.units[performerKey]
    const target = Stage.findUnitByPosition(stage, position)
    if(target == undefined) return 0.1
    if(target != undefined
    && target.affiliation == performer.affiliation) {
        return 5
    } else {
        return 4
    }
}

const skills = {}

skills["ember/harvest"] = {
    "key": "ember/harvest",
    "name": "Harvest",
    "role": "harvest",

    "type": "invoke",
    "range": 1,

    "isHidden": true,

    "getPriority": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0
        return 6
    },

    "canTarget": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        return target.type == "thing"
            && target.role == "plant"
        return false
    },

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        // const distance = Geometry.distance(position, performer.position)

        Step.add(step, {"mark": 180, "audio": {"triggerKey": "Unit:Harvest"}})
        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        const target = Stage.findUnitByPosition(step.omegastage, position)
        if(target == undefined) return step

        if(target.type == "thing"
        && target.role == "plant") {
            Step.add(step, {"mark": 200, ...Step.deltaflag("tutorial:hasLooted", true)})
            Step.add(step, {
                "mark": 200,
                "unit": {
                    "key": target.key,
                    "health": target.health - 10,
                }
            })

            if(target.protoinventory != undefined) {
                if(target.protoinventory.items != undefined) {
                    target.protoinventory.items.forEach((item) => {
                        if(item == undefined) return
                        const itemKey = item.key || stage.random.identifier()

                        Step.add(step, {
                            "mark": 200,
                            "unit": {
                                "key": performer.key,
                                // "items": {
                                //     [itemKey]: {
                                //         "key": itemKey,
                                //         ...item
                                //     }
                                // }
                            }
                        })
                        if(item.image != undefined) {
                            // Step.add(step, PlotFlourishes.ImageFloat({
                            //     "mark": 200,
                            //     "position": target.position,
                            //     "image": item.image
                            // }))
                            Step.add(step, PlotFlourishes.TextFloat({
                                "mark": 200,
                                // "type": "healing",
                                "position": target.position,
                                "text": "+1 food",
                            }))
                        }
                        // Step.add(step, {
                        //     "mark": 200,
                        //     "unit": {
                        //         "key": target.key,
                        //         "items": {
                        //             [item.key]: undefined
                        //         }
                        //     }
                        // })
                    })
                }
            }
            // const item = Object.values(target.inventory?.items || [])[0]
            // "protoitem": {
            // "inventory": {
            //     "items": {
            //         [itemKey]: {
            //             "key": itemKey,
            //             "name": "Squash",
            //             "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            //         }
            //     }
            // }

            Step.add(step, {
                "mark": 200,
                "player": {
                    "inventory": {
                        "kindling": (stage?.player?.inventory?.kindling || 0) + 1
                    }
                }
            })
        }

        return step
    }
}

skills["ember/recruit"] = {
    "key": "recruit",
    "name": "Recruit",
    "role": "support",

    "type": "invoke",
    "range": 1,

    "isHidden": true,

    "getPriority": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0
        if(target.affiliation == "none") return 6
        if(target.affiliation == "neutral") return 6
        if(target.affiliation == "nothing") return 6
        return 0
    },

    "canTarget": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation == "none") return true
        if(target.affiliation == "neutral") return true
        if(target.affiliation == "nothing") return true
        return false
    },

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        let steps = []
        steps.push(step)

        const performer = step.omegastage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        // const distance = Geometry.distance(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 180, "audio": {"triggerKey": performer.attackaudio ?? "Unit:Attack:Melee"}})

        const target = Stage.findUnitByPosition(step.omegastage, position)
        if(target == undefined) return step

        if(target.affiliation == "none"
        || target.affiliation == "neutral") {
            Step.add(step, {
                "mark": 200,
                "unit": {
                    "key": target.key,
                    "affiliation": performer.affiliation,
                }
            })

            stage.scripts.forEach((condition) => {
                if(condition.trigger == "recruiting"
                && condition.canBeTriggered(stage, performer, target) == true) {
                    const conditionEvents = condition.events
                    conditionEvents.unshift({
                        "omegastage": stage,
                        "name": "SavestateCapture",
                        "savestateSlug": condition.title || "Condition_" + stage.scripts.indexOf(condition),
                    })
                    steps = steps.concat(Stage.processEventSteps(step.omegastage, conditionEvents))
                }
            })
        }

        return steps
    }
}

skills["ember/kindle"] = {
    "key": "ember/kindle",
    "name": "Kindle",
    "role": "kindle",

    "type": "invoke",
    "range": 1,

    "isHidden": true,

    "getPriority": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0
        return 6
    },

    "canTarget": function({performerKey, stage, position}) {
        // const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        return target.type == "thing"
            && target.role == "torch"
            && stage?.player?.inventory?.kindling > 0
    },

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        // const distance = Geometry.distance(position, performer.position)

        Step.add(step, {"mark": 180, "audio": {"triggerKey": "Unit:Kindle"}})
        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        const target = Stage.findUnitByPosition(step.omegastage, position)
        if(target == undefined) return step

        if(target.type == "thing"
        && target.role == "torch"
        && stage?.player?.inventory?.kindling > 0) {
            const flameCount = target.data?.flameCount || 0
            for(let i = 1; i <= flameCount; i += 1) {
                Step.add(step, {
                    "mark": 200 + (50 * (i - 1)),
                    "unit": {
                        ...emberUnitJobs["ember/flame"],
                        "key": "flame" + i, // stage.random.id(), // TODO: for osme reason using stage.random.id rerendered all the dice animations???

                        "maxhealth": 10 + (i * 10),
                        "sprites": {
                            "idle": target.sprites["flame" + i],
                        },
                        "position": {
                            "x": target.position.x,
                            "y": target.position.y,
                            "z": target.position.z,
                        },
                        "stack": 10 + (i - target.data.flameCount),
                    }
                })
            }
            Step.add(step, {
                "mark": 200,
                "player": {
                    "inventory": {
                        "kindling": stage.player.inventory.kindling - flameCount
                    }
                }
            })
            Step.add(step, PlotFlourishes.TextFloat({
                "mark": 200,
                // "type": "healing",
                "unitKey": target.key,
                "position": target.position,
                "text": "-" + flameCount + " kindling",
            }))
        }

        return step
    }
}

skills["ember/burnout"] = {
    "key": "ember/burnout",
    "type": "at-end-of-player-turn",
    "isHidden": true,
    "range": 0,

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        Step.add(step, {
            "mark": 0,
            "unit": {
                "key": performerKey,
                "health": performer.health - 10,
            }
        })

        if(performer.health == 0) {
            Step.add(step, PlotFlourishes.Shudder({
                "unitKey": performer.key,
                "position": performer.position,
                "intensity": 0.05,
            }))
        }

        return step
    }
}

export default skills
